/* @flow */
import * as React from "react";
import styled from "styled-components";
import moment from "moment";
import Gettext from "../common/Gettext";
import timer from "../../images/timer.svg";
import AnimationWrapper from "../AnimationWrapper";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 25px;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 20000;
  overflow: auto;

  @media (max-width: 959px) {
    padding: 0;
  }
`;

const PopupTable = styled.table`
  table-layout: fixed;
  width: 100%;
  height: 100%;
  margin: 0 auto;
`;

const Popup = styled.div`
  position: relative;
  width: 100%;
  max-width: 477px;
  margin: 0 auto;
  text-align: center;
  background-color: ${props => props.theme.mainHighlight};
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;

  @media (max-width: 959px) {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
    height: 100%;
    max-width: 100%;
    box-shadow: none;
  }
`;

const Close = styled.div`
  position: absolute;
  top: 16px;
  right: 12px;
  width: 19px;
  height: 19px;
  color: #96949b;
  transition: color 0.15s ease;
  cursor: pointer;

  @media (max-width: 959px) {
    top: 12px;

    > svg {
      stroke-width: 2px;
    }
  }

  :hover {
    color: #60a31c;
  }
`;

const Content = styled.div`
  padding: 25px;

  @media (max-width: 959px) {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    max-height: 470px;
  }
`;

const Title = styled.div`
  max-width: 390px;
  margin: 0 auto 22px;
  font-weight: 500;
  font-size: 22px;
  text-align: center;
  color: #e74c3c;

  @media (max-width: 959px) {
    font-size: 18px;
  }
`;

const Timer = styled.img`
  display: block;
  width: 52px;
  margin: 0 auto 25px;
`;

const TimeText = styled.div`
  margin-bottom: 5px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.2;
  text-align: center;
  color: #feac00;
`;

const Text = styled.div`
  margin-bottom: 32px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.2;
  text-align: center;
  color: #fff;

  @media (max-width: 959px) {
    margin-bottom: 20px;
  }
`;

const Disclamer = styled.div`
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 18px;
  text-align: center;
  color: ${props => props.theme.ticksFontColor};
`;

type Props = {
  time: number, // timestamp
  onDismiss: () => void
};

export function formatTimeInterval(ms: number) {
  const time = moment.duration(ms);
  const h = ("0" + time.hours()).slice(-2);
  const m = ("0" + time.minutes()).slice(-2);
  const s = ("0" + time.seconds()).slice(-2);

  return `${h}:${m}:${s}`;
}

function TradeIsClosing(props: Props) {
  return (
    <Overlay>
      <PopupTable>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "middle" }}>
              <AnimationWrapper>
              <Popup>
                <Close onClick={props.onDismiss}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 19.707 19.707"
                  >
                    <g>
                      <line x2="19" y2="19" stroke="currentColor" fill="none" />
                      <line x1="19" y2="19" stroke="currentColor" fill="none" />
                    </g>
                  </svg>
                </Close>
                <Content>
                  <Title>
                    <Gettext>The opening of a trade is not possible</Gettext>
                  </Title>
                  <div>
                    <Timer src={timer} alt="" />
                    <TimeText>{formatTimeInterval(props.time)}</TimeText>
                    <Text>
                      <Gettext>left till the market closure</Gettext>
                    </Text>
                  </div>
                  <Disclamer>
                    <Gettext>
                      Trading with this asset will be closed soon. Please choose
                      the earlier expiration time.
                    </Gettext>
                  </Disclamer>
                </Content>
              </Popup>
              </AnimationWrapper>
            </td>
          </tr>
        </tbody>
      </PopupTable>
    </Overlay>
  );
}

export default TradeIsClosing;



// WEBPACK FOOTER //
// ./src/components/TradeModals/TradeIsClosing.js